export const ImageUrl = "https://node.thelearningexpressar.org:3000/uploads/images/"
export const DocumentUrl = "https://node.thelearningexpressar.org:3000/uploads/docs/"
